var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function isGradient(style) {
    return (style !== null &&
        typeof style === 'object' &&
        'stops' in style &&
        'type' in style);
}
export function isPattern(style) {
    return style !== null && typeof style === 'object' && style.type === 'pattern';
}
export function gradientToCss(g) {
    var stops = g.stops.map(function (s) { return "".concat(s.color, " ").concat(s.offset * 100, "%"); }).join(', ');
    if (g.type === 'radial') {
        return "radial-gradient(circle at ".concat(g.x0, "px ").concat(g.y0, "px, ").concat(stops, ")");
    }
    var angle = Math.atan2(g.y1 - g.y0, g.x1 - g.x0) * (180 / Math.PI) + 90;
    return "linear-gradient(".concat(angle, "deg, ").concat(stops, ")");
}
export function createSvgGradient(doc, id, g) {
    var _a;
    var ns = 'http://www.w3.org/2000/svg';
    if (g.type === 'radial') {
        var el_1 = doc.createElementNS(ns, 'radialGradient');
        el_1.setAttribute('id', id);
        el_1.setAttribute('cx', String(g.x0));
        el_1.setAttribute('cy', String(g.y0));
        el_1.setAttribute('r', String((_a = g.r1) !== null && _a !== void 0 ? _a : 50));
        appendStops(doc, el_1, g);
        return el_1;
    }
    var el = doc.createElementNS(ns, 'linearGradient');
    el.setAttribute('id', id);
    el.setAttribute('x1', String(g.x0));
    el.setAttribute('y1', String(g.y0));
    el.setAttribute('x2', String(g.x1));
    el.setAttribute('y2', String(g.y1));
    appendStops(doc, el, g);
    return el;
}
function appendStops(doc, gradient, g) {
    var e_1, _a;
    var ns = 'http://www.w3.org/2000/svg';
    try {
        for (var _b = __values(g.stops), _c = _b.next(); !_c.done; _c = _b.next()) {
            var stop_1 = _c.value;
            var el = doc.createElementNS(ns, 'stop');
            el.setAttribute('offset', String(stop_1.offset));
            el.setAttribute('stop-color', stop_1.color);
            gradient.appendChild(el);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function shadowToCss(shadow) {
    return "".concat(shadow.offsetX, "px ").concat(shadow.offsetY, "px ").concat(shadow.blur, "px ").concat(shadow.color);
}
export function createSvgShadowFilter(doc, id, shadow) {
    var ns = 'http://www.w3.org/2000/svg';
    var filter = doc.createElementNS(ns, 'filter');
    filter.setAttribute('id', id);
    filter.setAttribute('x', '-50%');
    filter.setAttribute('y', '-50%');
    filter.setAttribute('width', '200%');
    filter.setAttribute('height', '200%');
    var blur = doc.createElementNS(ns, 'feGaussianBlur');
    blur.setAttribute('in', 'SourceAlpha');
    blur.setAttribute('stdDeviation', String(shadow.blur / 2));
    blur.setAttribute('result', 'blur');
    var offset = doc.createElementNS(ns, 'feOffset');
    offset.setAttribute('in', 'blur');
    offset.setAttribute('dx', String(shadow.offsetX));
    offset.setAttribute('dy', String(shadow.offsetY));
    offset.setAttribute('result', 'offsetBlur');
    var flood = doc.createElementNS(ns, 'feFlood');
    flood.setAttribute('flood-color', shadow.color);
    flood.setAttribute('result', 'color');
    var composite = doc.createElementNS(ns, 'feComposite');
    composite.setAttribute('in', 'color');
    composite.setAttribute('in2', 'offsetBlur');
    composite.setAttribute('operator', 'in');
    composite.setAttribute('result', 'shadow');
    var merge = doc.createElementNS(ns, 'feMerge');
    var n1 = doc.createElementNS(ns, 'feMergeNode');
    n1.setAttribute('in', 'shadow');
    var n2 = doc.createElementNS(ns, 'feMergeNode');
    n2.setAttribute('in', 'SourceGraphic');
    merge.appendChild(n1);
    merge.appendChild(n2);
    filter.appendChild(blur);
    filter.appendChild(offset);
    filter.appendChild(flood);
    filter.appendChild(composite);
    filter.appendChild(merge);
    return filter;
}
export function setCanvasFill(ctx, fill, patternCache) {
    var e_2, _a;
    var _b, _c;
    if (!fill)
        return;
    if (typeof fill === 'string') {
        ctx.fillStyle = fill;
    }
    else if (isGradient(fill)) {
        var grad = fill.type === 'linear'
            ? ctx.createLinearGradient(fill.x0, fill.y0, fill.x1, fill.y1)
            : ctx.createRadialGradient(fill.x0, fill.y0, (_b = fill.r0) !== null && _b !== void 0 ? _b : 0, fill.x1, fill.y1, (_c = fill.r1) !== null && _c !== void 0 ? _c : 50);
        try {
            for (var _d = __values(fill.stops), _e = _d.next(); !_e.done; _e = _d.next()) {
                var stop_2 = _e.value;
                grad.addColorStop(stop_2.offset, stop_2.color);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_2) throw e_2.error; }
        }
        ctx.fillStyle = grad;
    }
    else if (isPattern(fill)) {
        var key = typeof fill.source === 'string' ? fill.source : 'canvas-pattern';
        var pattern = patternCache === null || patternCache === void 0 ? void 0 : patternCache.get(key);
        if (!pattern && typeof fill.source !== 'string') {
            var created = ctx.createPattern(fill.source, fill.repeat);
            if (created) {
                pattern = created;
                if (patternCache)
                    patternCache.set(key, pattern);
            }
        }
        if (pattern)
            ctx.fillStyle = pattern;
    }
}
export function setCanvasStroke(ctx, stroke) {
    if (!stroke)
        return;
    if (typeof stroke === 'string') {
        ctx.strokeStyle = stroke;
    }
    else if (isGradient(stroke)) {
        setCanvasFill(ctx, stroke);
        ctx.strokeStyle = ctx.fillStyle;
    }
}
export function fillStyleRef(style, prefix, id) {
    if (typeof style === 'string')
        return style;
    if (isGradient(style) || isPattern(style))
        return "url(#".concat(prefix, "-").concat(id, ")");
    return 'none';
}
